
import React from 'react';
import {DUMMY} from "../helpers/functions"
import { Card} from "react-bootstrap"

const AboutCard = ({ image = "", title = "", variant = "", children = <></>, onClick= DUMMY("handle flip")}) =>
(
  <Card className="bg-dark text-white" onClick={onClick}>
    <Card.Img src={image} alt="Card image"/>
    <Card.ImgOverlay>
      <Card.Title>{title}</Card.Title>
      <Card.Body> {children}</Card.Body>
    </Card.ImgOverlay>
  </Card>
)


export default AboutCard;
